module.exports = __webpack_public_path__ + "fonts/Montserrat-BoldItalic.f6d9bf81.WOFF";